<template>
  <div class="app">
    <nav class="menu">
      <div class="content">
        <img src="../assets/logo.png"/>
        <span class="name">爱德主机实操模拟</span>
        <div class="right-menu">
          <a href="/">网站首页</a>
          <a href="/contact">联系我们</a>
          <a  class="selected">用户协议</a>
        </div>
      </div>
    </nav>
    <div class="container">
      <div class="main-wrapper index">
        <div class="main index">
          <div class="index-content">
            <div class="title">爱德主机实操模拟</div>
            <div class="sub-title">
              <span>爱德主机实操模拟全面覆盖考试内容，精心筛选真题与模拟题，提供多种学习资源，满足不同学员需求。</span>
              <span>爱德主机实操模拟采用科学练题模式，含章节练习、真题模拟等，结合智能错题本，助力精准复习。名师解析题目，揭示高频考点，确保学员掌握核心知识。</span>
              <span>爱德主机实操模拟考试必备，精选题库、名师解析，助您高效提分、轻松通关！ </span>
            </div>
          </div>
          <div class="video"><img src="../assets/video.png"/></div>
        </div>
      </div>      
      <div class="main-wrapper about">
        <div class="main">
          <h3>《 用户协议 》</h3>
          <div class="protocol">
            <p>平台用户协议（以下简称“本协议”）由以下双方根据《中华人民共和国合同法》等相关法律法规签署并遵照执行。</p>
						<p>用户：在手机、平板电脑、电脑等注册成为平台（以下简称“平台”或“平台方”）的使用者，通过平台发布、查看、接收图文/音频/视频信息或其他文件，或与其他用户进行延时/实时交流的用户（以下简称“用户”）。</p>
						<p>平台方：上海爻塔科技有限公司（以下简称“平台方”）。</p>
						<p>本协议所指“用户”包括但不限于教师身份用户、家长身份用户和学生身份用户。</p>
						<p class="h">第一条 用户注册</p>
						<p>1.1用户下载平台并根据平台的注册规则完成注册流程（包括但不限于设置用户名称及密码）后，即有权通过平台发布、查看、接收图文/音频/视频信息或其他文件，或与其他用户进行延时/实时交流。用户在平台上有效注册（或有效变更注册）的用户名及密码共同构成用户在平台的唯一有效身份证明。</p>
						<p>1.2用户一旦完成注册，则视为用户允许平台方通过短信、电子邮件、APP/服务器推送或其他方式向其发送与平台相关的信息。</p>
						<p>1.3用户应当保证其完成上述注册（或变更注册）时所提供的身份信息及电话、电子邮箱等必要信息真实、准确、有效；如此类信息有任何变动，用户应当在三日内通过平台完成信息更新。因用户提供虚假或无效信息导致平台方或其他用户遭受损失的，用户应当承担全部责任。</p>
						<p>1.4用户应自行妥善保管用户名及密码，除经平台方事先书面同意或本协议另有约定外，不得将其赠予、转让、出售或出借于他人使用；如用户发现其用户名及密码遭他人使用，应立即通知平台方以避免损失或损失扩大。因网络攻击、用户保管用户名及密码不当、转让或出借用户名及密码、怠于履行本协议及其他相关协议下的通知义务等情形或其他非平台方原因，导致用户未能正常使用平台或遭受任何损失的，由用户自行担责，平台方不承担任何责任。</p>
						<p>1.5用户需自行确认，在开始注册使用平台前，其应当具备中华人民共和国法律规定的与其行为相适应的民事行为能力。若用户不具备前述与用户行为相适应的民事行为能力，则其监护人应依照法律规定承担此用户行为产生的一切法律后果（未成年人应在其监护人监督指导下使用平台）。</p>
						<p>1.6用户注册的账户为用户自行设置并由用户自行保管，平台方任何时候均不会主动要求用户提供其账户密码。用户账户因用户的主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，平台方不承担责任，用户应自行通过司法、行政等救济途径向侵权行为人追偿。</p>
						<p>1.7如发生以下情形，平台方有权收回用户注册的账户，用户将不能再登录平台，相应服务同时终止：</p>
						<p>（一）经发现非由注册用户本人实际使用的；</p>
						<p>（二）连续三个月未用于登录平台；</p>
						<p>（三）其他平台方认为有必要的情形。</p>
						<p>1.8用户一旦完成注册，即视为完全了解、接受并同意遵守本协议项下的全部内容并受限于本协议相关条款。平台方有权根据法律法规、政策以及运营中的实际情况对协议进行修改，并对用户进行公布。修改后的协议条款一经平台方公布即替换本协议的原条款，构成用户与平台方之间就本协议的全部、最新协议。用户可以随时在平台应用程序中查阅最新协议条款。如果用户不接受平台方修改后的最新协议条款，可选择停止使用平台并注销其账户。如用户选择继续使用平台，则视为用户完全了解、接受并同意遵守平台方修改后的最新协议条款。用户承认并认可，已经完全了解并理解本协议相关内容，对本协议及相关内容不存在任何重大误解；同时认可本协议内容并不存在显失公平的情形，用户与平台方在协议中处于平等地位，用户对协议的接受与否具有自由选择的权利。</p>
						<p class="h">第二条 服务内容</p>
						<p>2.1平台方为用户提供发布、查看、接收图文/音频/视频信息或其他文件，或与其他用户进行延时/实时交流的服务。</p>
						<p>2.2平台方作为平台软件的设计/开发/所有/经营者，有权对于平台软件不时作出更新和调整，只要用户仍为平台的注册用户，即视为其同意平台方作出的任何更新和调整。</p>
						<p>2.3平台方仅为用户提供发布、查看、接收图文/音频/视频信息或其他文件，或与其他用户进行延时/实时交流的技术支持，因用户自身原因造成的延迟确认、延迟回复、未按时保存、操作失误等情形，平台方不承担任何责任。</p>
						<p>2.4用户应当知晓在使用平台软件的过程中可能存在由其他用户进行通知、提醒、审批、定时、评论、发起问卷、投票等行为设置，平台方仅为前述行为提供技术支持，前述行为均为用户自身行为，与平台方无关。</p>
						<p>2.5用户应当知晓在使用平台软件的过程中可能涉及第三方服务软件的参与（包括但不限于微信、QQ、支付宝等），因前述第三方服务软件所造成的信息提供错误、信息提供延误、信息泄露、连接错误、服务器故障等情形与平台方无关。</p>
						<p class="h">第三条 各方的权利义务</p>
						<p>3.1 用户的权利义务</p>
						<p>3.1.1用户应遵守中国有关的法律法规规定及本协议约定条款。</p>
						<p>3.1.2用户向平台提供的各类信息应真实、准确、完整；用户在平台发布的各类信息（包括但不限于图文、音频、视频等）应符合中国有关的法律法规；用户通过平台进行的延时/实时交流活动应当符合中国有关的法律法规。经平台方发现用户违反前述约定的，用户向平台提供/发布的信息将不再适用本合同有关隐私保护的约定，平台方有权公示、向政府部门进行举报或直接向用户追究法律责任。平台方在任何时候有权验证用户提供/发布的信息，由于用户提供虚假或不完整信息所导致的任何责任和损失，应由用户自行承担。</p>
						<p>3.1.3用户利用平台发布虚假、侵犯他人隐私、侵犯他人知识产权、侮辱他人、造谣诽谤等违反法律法规或公序良俗的内容从而给平台方、其他用户或第三方造成损害的，由前述用户承担全部法律后果及赔偿责任。</p>
						<p>3.1.4用户不得有任何损害平台方权益的行为，若用户损害平台方权益的，平台方有权要求用户承担赔偿责任，情节严重的平台方将保留追究其法律责任的权利。</p>
						<p>3.1.5平台方暂时免费向用户提供本协议约定之服务，但平台方保留将来向用户收取费用的权利。用户之间自行产生的任何费用支付均与平台方无关。</p>
						<p>3.2平台方的权利义务</p>
						<p>3.2.1在平台的变更、更新、优化后，及时通知用户。</p>
						<p>3.2.2平台无法保证其所提供的信息中没有任何错误、缺陷、恶意软件或病毒。对于因使用（或无法使用）平台导致的任何损害，平台不承担责任（除非此类损害是由平台的故意或重大疏忽造成的）。此外，对于因使用（或无法使用）与平台的电子通信手段导致的任何损害，包括但不限于因电子通信传达失败或延时、第三方或用于电子通信的计算机程序对电子通信的拦截或操纵，以及病毒传输导致的损害，平台不承担责任。</p>
						<p class="h">第四条 其他责任约定</p>
						<p>4.1因不可抗力（指本协议约定时不能预见、不能避免并不能克服的客观情况）导致平台方未能按约提供服务的，平台方不承担责任。</p>
						<p>4.2服务过程中因协议双方以外的其他第三方原因造成的损失，由该第三方承担法律后果及赔偿责任。</p>
						<p class="h">第五条 用户信息</p>
						<p>5.1 用户信息包含用户个人信息和用户非个人信息。</p>
						<p>5.2用户个人信息包括但不限于下列信息：用户真实姓名、性别、职业、任职/就读学校、头像、手机号码、IP地址等。</p>
						<p>5.3用户非个人信息包括但不限下列信息：一切属于第5.2条所述的用户个人信息范围以外的信息，均为普通信息，不属于用户个人信息；包括但不限于用户对平台服务的操作状态、使用记录、使用习惯等反应在平台方服务器端的全部记录信息。</p>
						<p>5.4重要提示：为向客户提供本协议所述服务，平台方将可能合理使用用户个人信息和非用户个人信息。用户一旦注册、登录、使用平台，将视为用户完全了解、同意并接受平台方通过包括但不限于收集、统计、分析、使用等方式合理使用用户信息，无需其他意思表示。为向用户完整地提供包括但不限于本协议所述的服务，平台方将可能要求用户上传用户信息（包括但不限于通讯录等），用户一旦选择上传用户信息，将视为用户完全了解、同意并接受平台方基于向用户提供服务的目的读取并合理使用用户信息。</p>
						<p>5.5用户认可其已完全了解平台方使用用户信息的目的在于为用户提供包括本协议所述的服务或将来可能新增的服务，平台方使用用户信息的方式包括但不限于：收集、统计、分析、商业用途的使用等方式；平台方使用用户信息的范围包括但不限于本条第5.2条、5.3条、5.4条所定义的信息等。</p>
						<p>5.6用户可以通过停止使用平台而不再向平台方提供用户信息。但是，在此之前已同意平台方使用的用户信息，平台方不承担主动删除、销毁的责任，并仍具有使用此类用户信息的权利。</p>
          </div>
        </div>
      </div>
      <div class="main-wrapper footer">
        <div class="main" style="font-weight:normal">
          Copyright &COPY; 2024 爱德主机实操模拟  <a href="https://beian.miit.gov.cn" style="color:#333;text-decoration: none;">沪ICP备2024055314号-2</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yaml from 'js-yaml'
import axios from 'axios'
export default {
  name: 'app',
  data() {
    return {
      showios: false,
      showand: false,
      download: '',
      config: '',
      text: '点击下载Windows客户端 (64位)',
      visible: false,
      cvisible: false
    };
  },
  methods: {
    showcode(key) {
      if (key === 'ios') {
        this.showios = true
      } else {
        this.showand = true
      }
    },
    hidecode(key) {
      if (key === 'ios') {
        this.showios = false
      }else{
        this.showand = false
      }
    },
    downloadClient(){
      location.href = this.download
    }
  },
  mounted() {
    // this.getPosType()
  }
};
</script>

<style lang="less" scoped>
@font-face {
	  font-family: 'Truth';
	  src: url('../assets/fonts/truth.woff') format('woff'), url('../assets/fonts/truth.otf') format('otf'), url('../assets/fonts/truth.ttf') format('opentype');
	  font-style: normal;
	  font-weight: normal;
	}
html,
body {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  width: 100%;
  /* overflow: hidden; */
  font-family: "microsoft yahei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.app {
  /* height: 100%; */
  width: 100%;
}
p {
  /* margin: 0; */
  /* text-align: center; */
  /* width: 800px; */
  margin: 0 auto;
}
h1,h3,h4,h2,h5{
  padding: 0;
  margin: 0;
}
h3{
  font-size: 32px;
  margin-bottom: 20px;
  // font-family: 'Truth';
  font-weight: 500;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}
.container{
  width: 100%;
}
.menu{
  // position: absolute;
  // left: 0;
  // right: 0;
  // top: 0;
  background: rgba(255, 255, 255, 1);
  .content{
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 15px 0;
    font-size: 24px;
    // justify-content: space-between;
    img{
      width: 48px;
      height: 48px;
      margin-right: 10px ;
      border-radius: 10px;
      border: 1px solid #F5F5F5;

    }
    .name{
      color: #333;
      font-size: 26px;
      font-weight: 700;
      font-family: 'Truth';
    }
  }
  .right-menu{
    font-size: 16px;
    color: #333;
    cursor: pointer;
    // font-weight: 500;
    margin-left: auto;
    a{
      width: 140px;
      display: inline-block;
      text-align: center;
      text-decoration: none;
			color: #333;
      &.selected{
        color: #007FFF;
        position: relative;
        &::before{
          content: '';
          position: absolute;
          width: 30px;
          height: 2px;
          background: #007FFF;
          left: 50%;
          transform: translateX(-50%);
          bottom: -5px;
          border-radius: 4px;
        }
      }
    }
  }
  .free{
    margin-right: 30px;
    color: #007FFF;
    position: relative;
    &::before{
      content: '免费';
      font-size: 6px;
      position: absolute;
      right: -20px;
      top: -15px;
      background-color: #CE5653;
      color: #fff;
      padding: 0 5px;
      border-radius: 10px;
    }
  }
}

.main{
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  /* display: inline-block; */
  &.index{
    // margin-top: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: space-between;
    margin: 30px auto;
    h1{
      font-size: 48px;
    }
    h4{
      font-size: 36px;
      font-weight: 400;
      margin-top: 20px;
      margin-bottom: 50px;
    }
    .video{
      width: 405px;
      height: 420px;
      img{
        width: 405px;
      height: 420px;
      }
    }
    
  }
  &.resume{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.button-code{
  width: 190px;
  height: 50px;
  border-radius: 50px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #333;
  cursor: pointer;
  img{
    width: 20px;
    height: 22px;
    margin-right: 20px;
  }
}
.index-phone {
  display: inline-block;
  img{
    width: 264px;
    margin-right: 150px;
  }
}
.index-content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .title{
    font-size: 58px;
    font-weight: 600;
    font-family: 'Truth';
    color: #333;
    display: flex;
    align-items: flex-end;
  }
  .sub-title{
    margin-top: 20px;
    font-size: 18px;
    color: #999;
    display: flex;
    flex-direction: column;
    // align-items: flex-start;
    // justify-content: space-between;
    span{
      position: relative;
      // padding-left: 20px;
      line-height: 30px;
      text-align: left;

    }
  }
}
.buttons{
  .pc{
    display: flex;
    align-items: center;
    width: 500px;
    background: #007FFF;
    border-radius: 50px;
    justify-content: center;
    height: 44px;
    cursor: pointer;
    margin-top: 50px;
    img{
      height: 20px;
      margin-right: 10px;
    }
  }
  
}
.main-wrapper{
  width: 100%;
  display: inline-block;
  &.index{
    height: 500px;
    // background: url('../assets/bgggg.png');
    // background-size: 100% auto;
    background: linear-gradient(96deg, #FFF 3.15%, #bdd2e8 100%);
    
  }
  
  &.about{
    background: #fff;
    text-align: center;
    color: #333;
    padding: 60px 0;
    .protocol{
      margin: 40px 0;
			// display: flex;
			// align-items: center;
			border-radius: 8px;
			border-top: 1px dashed var(---, #E5E7EB);
			// padding: 12px;
			padding-top: 32px;			
      p{
        text-align: left;
        line-height: 2.5;
        font-size: 14px;
        color: #666;
				margin: 0;
				&.h{
					font-size: 20px;
					font-weight: 500;
					color: #333;
				}
      }
    }
  }
  &.footer{
    background: #fff;
    padding: 32px 0;
    text-align: center;
    color: #333;
		border-top: 1px solid #EFEFEF;
  }
}
.popup{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  .p-body{
    position: absolute;
    width: 600px;
    height: 500px;
    background: #fff;
    color: #333;
    box-sizing: border-box;
    padding: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .p-title{
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    span{
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 30px;
      font-weight: 100;
      cursor: pointer;
      padding: 0 5px;
    }
  }
  p{
    line-height: 2;
    &.q{
      font-weight: 500;
      margin: 10px 0;
    }
    &.a{
      color: #666;

      font-size: 14px;
    }
  }
}
.items{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 50px;
  .item{
    width: 254px;
    text-align: center;
    display: flex;
    height: 182px;
    overflow: hidden;
    margin-bottom: 60px;
    img{
      width: 100%;
      height: 182px;
    }
    &:last-child{
      width: 569px;
    }
  }
}
.mutil{
  // margin-top: 80px;
  padding: 40px 0;
  // background: linear-gradient(90deg, rgba(29, 97, 232,0.3), rgba(211, 230, 252,0.3));
  color: #333;
  // background: url('../assets/mutilbg.png') no-repeat;
  // background-size: 100% auto;
}
.hezuo{
  color: #333;
  margin-top: 80px;
  margin-bottom: 80px;
  span{
    color: #CE5653;
  }
  .lists{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 40px;
    div{
      width: 240px;
      height: 240px;
      background: #fcfcfc;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #f4f4f4;
      border-bottom: 1px solid #f4f4f4;
      box-sizing: border-box;
      &:hover{
        background: rgba(55, 111, 246, 0.3);
      }
    }
    img{
      width: 120px;
      height: 120px;
      border-radius: 120px;
    }
  }
}
.color{
  color:#CE5653 ;
}
@media screen and (max-width: 768px) {
  .menu{
    .content{
      padding: 15px 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .right-menu{
      display: none;
    }
  }
  .index-content{
    .title{
      font-size: 30px;
      // flex-direction: column;
      align-items: flex-end;
      div{      
        span:first-child{
          color: #CE5653;
          font-family: 'Truth';
          font-size: 30px;
        }
      }
      .subfix{
        // margin-left: 0;
        font-size: 17px;
        // margin-top: 10px;
      }
    }
  }
  .sub-title{
    .pc,.phone{
      display: none;
    }
    span::before{
      top:8px !important;
      margin-top: 0 !important;
    }
  }
  .h5{
      display: inline-block !important;
      margin-bottom: 5px;
    }
  .buttons{
    display: none;
  }
  .main.index{
    flex-direction: column;
    width: 100%;
    margin-top: 100px;
    box-sizing: border-box;
    padding: 0 20px;
    justify-content: center;
    .video {
      width: 100%;
      height: auto;
      margin-top: 40px;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .main-wrapper.index{
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 520px;
    .app{
      display: none;
    }
  }
  .main-wrapper.jobs{
    display: none;
  }
  .main{
    width: 100%;
  }
  .hezuo{
    margin-top: 40px;
    margin-bottom: 40px;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .hezuo .lists{
    width:100%;
    justify-content: center;
    div{
      width: 50%;
    }
  }
  .main-wrapper.demo {
    .lists{
      box-sizing: border-box;
      padding: 0 20px;
      .item{
        margin-bottom: 20px;
      }
      img{
        width:100%;
        height: auto;
      }
    }
  }
  .main-wrapper.footer{
    font-size: 14px;
  }
  .mutil{
    background-size: auto 100%;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  h3{
    font-size: 28px;
  }
  p,span{
    text-align: left;
  }
}
</style>
